import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';

/** Reconstruit le schéma de validation à chaque changement de langue. */
export function useLocalizedSchema<T>(factory: (t: TFunction) => T): T {
  const { t, i18n } = useTranslation();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => factory(t), [i18n.language]);
}

/**
 * Revalide le formulaire après un changement de langue, sinon les erreurs déjà
 * affichées restent dans l'ancienne langue jusqu'à la prochaine saisie.
 */
export function useRevalidateOnLanguageChange(
  trigger: () => Promise<boolean> | void,
  isSubmitted: boolean
) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (isSubmitted) {
      void trigger();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);
}
